import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './tab-selector.css'

const TabSelector = (props) => {
  const [tabSelector1, setTabSelector1] = useState(1)
  const [tabSelector, setTabSelector] = useState(1)
  return (
    <div className={`tab-selector-container ${props.rootClassName} `}>
      <div className="tab-selector-thq-frame135-elm">
        <div className="tab-selector-thq-frame141-elm">
          <span className="tab-selector-thq-text-elm10 HeadingH1SB">
            {props.onClickBg ?? (
              <Fragment>
                <span className="tab-selector-text22">
                  Smart Card Production Process
                </span>
              </Fragment>
            )}
          </span>
          {tabSelector1 === 1 && (
            <div className="tab-selector-thq-frame348-elm1">
              {tabSelector1 === 1 && (
                <div className="tab-selector-thq-card-production-button-elm1">
                  <span className="tab-selector-thq-text-elm11 BodyB1R">
                    {props.text2 ?? (
                      <Fragment>
                        <span className="tab-selector-text31">
                          Card Production
                        </span>
                      </Fragment>
                    )}
                  </span>
                </div>
              )}
              <div
                onClick={() => {
                  setTabSelector1(2)
                  setTabSelector(2)
                }}
                className="tab-selector-thq-ic-module-button-elm1"
              >
                <span className="tab-selector-thq-text-elm12 BodyB1R">
                  {props.text21 ?? (
                    <Fragment>
                      <span className="tab-selector-text26">IC Module</span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div
                onClick={() => {
                  setTabSelector1(3)
                  setTabSelector(3)
                }}
                className="tab-selector-thq-smart-card-button-elm1"
              >
                <span className="tab-selector-thq-text-elm13 BodyB1R">
                  {props.text3 ?? (
                    <Fragment>
                      <span className="tab-selector-text15">
                        Smart Card &amp; Personalization
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          )}
          {tabSelector1 === 2 && (
            <div className="tab-selector-thq-frame348-elm2">
              <div
                onClick={() => {
                  setTabSelector1(1)
                  setTabSelector(1)
                }}
                className="tab-selector-thq-card-production-button-elm2"
              >
                <span className="tab-selector-thq-text-elm14 BodyB1R">
                  {props.text22 ?? (
                    <Fragment>
                      <span className="tab-selector-text27">
                        Card Production
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-ic-module-button-elm2">
                <span className="tab-selector-thq-text-elm15 BodyB1R">
                  {props.text211 ?? (
                    <Fragment>
                      <span className="tab-selector-text13">IC Module</span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div
                onClick={() => {
                  setTabSelector(3)
                  setTabSelector1(3)
                }}
                className="tab-selector-thq-smart-card-button-elm2"
              >
                <span className="tab-selector-thq-text-elm16 BodyB1R">
                  {props.text31 ?? (
                    <Fragment>
                      <span className="tab-selector-text16">
                        Smart Card &amp; Personalization
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          )}
          {tabSelector1 === 3 && (
            <div className="tab-selector-thq-frame348-elm3">
              <div
                onClick={() => {
                  setTabSelector1(1)
                  setTabSelector(1)
                }}
                className="tab-selector-thq-card-production-button-elm3"
              >
                <span className="tab-selector-thq-text-elm17 BodyB1R">
                  {props.text221 ?? (
                    <Fragment>
                      <span className="tab-selector-text36">
                        Card Production
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div
                onClick={() => {
                  setTabSelector(2)
                  setTabSelector1(2)
                }}
                className="tab-selector-thq-ic-module-button-elm3"
              >
                <span className="tab-selector-thq-text-elm18 BodyB1R">
                  {props.text2111 ?? (
                    <Fragment>
                      <span className="tab-selector-text19">IC Module</span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-smart-card-button-elm3">
                <span className="tab-selector-thq-text-elm19 BodyB1R">
                  {props.text311 ?? (
                    <Fragment>
                      <span className="tab-selector-text24">
                        Smart Card &amp; Personalization
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
        {tabSelector === 1 && (
          <div className="tab-selector-thq-card-production-elm1">
            <div className="tab-selector-thq-frame353-elm1">
              <div className="tab-selector-thq-frame117-elm1">
                <div className="tab-selector-thq-frame119-elm1"></div>
                <span className="tab-selector-thq-text-elm20 HeadingH4M">
                  {props.text4 ?? (
                    <Fragment>
                      <span className="tab-selector-text11">Prepress</span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm21 BodyB3R">
                  {props.text5 ?? (
                    <Fragment>
                      <span className="tab-selector-text21">
                        This term used in the printing and publishing industries
                        for the processes and procedures that occur between the
                        creation of print layout and final printing.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame144-elm1">
                <div className="tab-selector-thq-frame120-elm10"></div>
                <span className="tab-selector-thq-text-elm22 HeadingH4M">
                  {props.text6 ?? (
                    <Fragment>
                      <span className="tab-selector-text33">
                        Sheet Printing
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm23 BodyB3R">
                  {props.text7 ?? (
                    <Fragment>
                      <span className="tab-selector-text39">
                        Before card producing, the front and back side layers
                        have to be printed with specific layout.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm1">
                <div className="tab-selector-thq-frame120-elm11"></div>
                <span className="tab-selector-thq-text-elm24 HeadingH4M">
                  {props.text8 ?? (
                    <Fragment>
                      <span className="tab-selector-text32">
                        Sheet Collating
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm25 BodyB3R">
                  {props.text9 ?? (
                    <Fragment>
                      <span className="tab-selector-text35">
                        This step means collating and alignment of different
                        sheetlayers for laminated cards.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="tab-selector-thq-frame354-elm1">
              <div className="tab-selector-thq-frame146-elm1">
                <div className="tab-selector-thq-frame120-elm12"></div>
                <span className="tab-selector-thq-text-elm26 HeadingH4M">
                  {props.text10 ?? (
                    <Fragment>
                      <span className="tab-selector-text10">
                        Sheet Laminating
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm27 BodyB3R">
                  {props.text11 ?? (
                    <Fragment>
                      <span className="tab-selector-text14">
                        After the correct alignment and prefixing of the single
                        sheet layers, they have to be laminated to get a stable
                        card body.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm2">
                <div className="tab-selector-thq-frame120-elm13"></div>
                <span className="tab-selector-thq-text-elm28 HeadingH4M">
                  {props.text12 ?? (
                    <Fragment>
                      <span className="tab-selector-text38">Card Punching</span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm29 BodyB3R">
                  {props.text13 ?? (
                    <Fragment>
                      <span className="tab-selector-text20">
                        At this process, a single card is punched out of the
                        laminated sheets.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
        {tabSelector === 3 && (
          <div className="tab-selector-thq-card-production-elm2">
            <div className="tab-selector-thq-frame353-elm2">
              <div className="tab-selector-thq-frame117-elm2">
                <div className="tab-selector-thq-frame119-elm2"></div>
                <span className="tab-selector-thq-text-elm30 HeadingH4M">
                  {props.text41 ?? (
                    <Fragment>
                      <span className="tab-selector-text12">
                        Combined Milling Implanting
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm31 BodyB3R">
                  {props.text51 ?? (
                    <Fragment>
                      <span className="tab-selector-text25">
                        This central process in the smart card production chain.
                        Chip modules are punched out of the tape, placed and
                        fixed in the cavity of card.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame144-elm2">
                <div className="tab-selector-thq-frame120-elm14"></div>
                <span className="tab-selector-thq-text-elm32 HeadingH4M">
                  {props.text61 ?? (
                    <Fragment>
                      <span className="tab-selector-text30">Plug Punching</span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm33 BodyB3R">
                  {props.text71 ?? (
                    <Fragment>
                      <span className="tab-selector-text18">
                        Plug punching is a precise process used to pre-punch SIM
                        plugs, ensuring consistent quality and accuracy for
                        optimal card performance.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm3">
                <div className="tab-selector-thq-frame120-elm15"></div>
                <span className="tab-selector-thq-text-elm34 HeadingH4M">
                  {props.text81 ?? (
                    <Fragment>
                      <span className="tab-selector-text17">
                        Personalization
                      </span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm35 BodyB3R">
                  {props.text91 ?? (
                    <Fragment>
                      <span className="tab-selector-text34">
                        This step will make each card into a distinctive, an
                        individual item which cannot be forgotten. The use of
                        the most-up-todate production technology supports every
                        type of optical personalization.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
            <div className="tab-selector-thq-frame354-elm2">
              <div className="tab-selector-thq-frame146-elm2">
                <div className="tab-selector-thq-frame120-elm16"></div>
                <span className="tab-selector-thq-text-elm36 HeadingH4M">
                  {props.text101 ?? (
                    <Fragment>
                      <span className="tab-selector-text29">Fulfillment</span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm37 BodyB3R">
                  {props.text111 ?? (
                    <Fragment>
                      <span className="tab-selector-text37">
                        A variety of fully secure solutions, ranging from simple
                        packages and card carriers are to more sophisticated
                        packs designed to convey a high-end image of your
                        product.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm4">
                <div className="tab-selector-thq-frame120-elm17"></div>
                <span className="tab-selector-thq-text-elm38 HeadingH4M">
                  {props.text121 ?? (
                    <Fragment>
                      <span className="tab-selector-text23">Delivery</span>
                    </Fragment>
                  )}
                </span>
                <span className="tab-selector-thq-text-elm39 BodyB3R">
                  {props.text131 ?? (
                    <Fragment>
                      <span className="tab-selector-text28">
                        After your smart card produced and packaged with your
                        special packaging, we are ready to deliver the smart
                        card into your place.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        )}
        {tabSelector === 2 && (
          <div className="tab-selector-thq-ic-module-elm">
            <div className="tab-selector-thq-frame353-elm3">
              <div className="tab-selector-thq-frame117-elm3">
                <div className="tab-selector-thq-frame119-elm3"></div>
                <span className="tab-selector-thq-text-elm40 HeadingH4M">
                  Die Bonder
                </span>
                <span className="tab-selector-thq-text-elm41 BodyB3R">
                  Die Bonder: Die bonding is assembly of the chip onto the IC
                  module tape.
                </span>
              </div>
              <div className="tab-selector-thq-frame144-elm3">
                <div className="tab-selector-thq-frame120-elm18"></div>
                <span className="tab-selector-thq-text-elm42 HeadingH4M">
                  Wire Bonder
                </span>
                <span className="tab-selector-thq-text-elm43 BodyB3R">
                  The contract pads of the chip are electrically connected pads
                  of the tape byapproximately 25 µm gold wires.
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm5">
                <div className="tab-selector-thq-frame120-elm19"></div>
                <span className="tab-selector-thq-text-elm44 HeadingH4M">
                  Chip module Encapsulation
                </span>
                <span className="tab-selector-thq-text-elm45 BodyB3R">
                  Resin is dispensed to protect the chip and wires against
                  mechanical and environmental stress.
                </span>
              </div>
            </div>
            <div className="tab-selector-thq-frame354-elm3">
              <div className="tab-selector-thq-frame146-elm3">
                <div className="tab-selector-thq-frame120-elm20"></div>
                <span className="tab-selector-thq-text-elm46 HeadingH4M">
                  Chip Module Test
                </span>
                <span className="tab-selector-thq-text-elm47 BodyB3R">
                  As an output of functional tests, IC modules are electrically
                  tested.
                </span>
              </div>
              <div className="tab-selector-thq-frame145-elm6">
                <div className="tab-selector-thq-frame120-elm21"></div>
                <span className="tab-selector-thq-text-elm48 HeadingH4M">
                  Glue Tape Lamination
                </span>
                <span className="tab-selector-thq-text-elm49 BodyB3R">
                  The preparation of the modules tape’s for the hot melt
                  implanting process. Chip modules are laminated on the backside
                  with an adhesive tape.
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

TabSelector.defaultProps = {
  text10: undefined,
  text4: undefined,
  text41: undefined,
  text211: undefined,
  text11: undefined,
  text3: undefined,
  text31: undefined,
  text81: undefined,
  text71: undefined,
  text2111: undefined,
  text13: undefined,
  text5: undefined,
  onClickBg: undefined,
  text121: undefined,
  text311: undefined,
  text51: undefined,
  text21: undefined,
  text22: undefined,
  text131: undefined,
  text101: undefined,
  text61: undefined,
  text2: undefined,
  text8: undefined,
  rootClassName: '',
  text6: undefined,
  text91: undefined,
  text9: undefined,
  text221: undefined,
  text111: undefined,
  text12: undefined,
  text7: undefined,
}

TabSelector.propTypes = {
  text10: PropTypes.element,
  text4: PropTypes.element,
  text41: PropTypes.element,
  text211: PropTypes.element,
  text11: PropTypes.element,
  text3: PropTypes.element,
  text31: PropTypes.element,
  text81: PropTypes.element,
  text71: PropTypes.element,
  text2111: PropTypes.element,
  text13: PropTypes.element,
  text5: PropTypes.element,
  onClickBg: PropTypes.element,
  text121: PropTypes.element,
  text311: PropTypes.element,
  text51: PropTypes.element,
  text21: PropTypes.element,
  text22: PropTypes.element,
  text131: PropTypes.element,
  text101: PropTypes.element,
  text61: PropTypes.element,
  text2: PropTypes.element,
  text8: PropTypes.element,
  rootClassName: PropTypes.string,
  text6: PropTypes.element,
  text91: PropTypes.element,
  text9: PropTypes.element,
  text221: PropTypes.element,
  text111: PropTypes.element,
  text12: PropTypes.element,
  text7: PropTypes.element,
}

export default TabSelector
